import React from 'react';

import { ICategory } from '@Hotels-at-Home/hah-fe-core/dist/types/category';
import { sanitizeHtml } from '@Hotels-at-Home/hah-fe-core/dist/utils';

interface IProps {
  category: ICategory;
}

const CategoryHeader = ({ category }: IProps) => (
  <div
    id="category-header"
    className="item ctg-header"
    data-event-name="bloc_interact"
    data-bloc-name={category.name}
  >
    <div className="stack">
      <h1 className="name">
        <span className="anchor-bar">
          <em data-gsap="grow" />
        </span>
        <span>{category.name}</span>
      </h1>
      <div
        className="description"
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(category.description) }}
      />
    </div>
  </div>
);

export default CategoryHeader;
